import React, {useState, useEffect} from 'react';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  SELECT_OPTIONS,
  SELLER_USER_SELECT_OPTIONS,
  UPDATE_ASSET_USERS
} from './queries';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import {
  MainContainer,
  ContentContainer
} from 'app/src/elements';
import Input from '../../elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';

const AssignToUsers = (props) => {
  const { sellerId, assetId, fromShow } = props;
  const [selectedUsers, setSelectedUsers] = useState(
    fromShow ? props.showSelectedUsers : []
  );
  const [selectedSellerUsers, setSelectedSellerUsers] = useState(
    fromShow ? props.showSelectedSellerUsers : []
  );
  const [selectOptions, setSelectOptions] = useState([]);
  const [sellerUserSelectOptions, setSellerUserSelectOptions] = useState([]);
  const { loading: loading, error: error, data: data } = useQuery(SELECT_OPTIONS);

  const [ loadSellerUsers, { loading: sellerUserLoading, data: sellerUserData } ] =
    useLazyQuery(SELLER_USER_SELECT_OPTIONS, {});
  const [updateAsset] = useMutation(UPDATE_ASSET_USERS, {
    onCompleted: () => {
      if(props.setShowModal) {
        props.setShowModal(false);
      }
    }
  });

  const onSubmit = () => {
    updateAsset({ variables: {
      id: assetId,
      userIds: selectedUsers,
      sellerUserIds: selectedSellerUsers
    }});
  }


  useEffect(() => {
    setSelectOptions(data)
  }, [data])
  useEffect(() => {
    setSellerUserSelectOptions(sellerUserData)
  }, [sellerUserData])
  useEffect(() => {
    if(sellerId) {
      loadSellerUsers({variables: {sellerId: sellerId}})
    }
  }, [sellerId])

  return (
    <View style={{maxWidth: '60vw'}}>
      <Input.MultiSelect
        selected={props.selectedUsers?.map(userId => {
          return userId
        }) || selectedUsers}
        setSelected={fromShow ?
          setSelectedUsers :
          props.setSelectedUsers
        }
        resourceType='Users'
        resources={selectOptions?.users?.map(user => {
          return { id: user.id, name: user.fullName}
        })}
      />
      <br />
      <Input.MultiSelect
        selected={props.selectedSellerUsers?.map(userId => {
          return userId
        }) || selectedSellerUsers}
        setSelected={fromShow ?
          setSelectedSellerUsers :
          props.setSelectedSellerUsers
        }
        resourceType='Seller Users'
        resources={sellerUserSelectOptions?.sellerUsers?.map(sellerUser => {
          return { id: sellerUser.id, name: sellerUser.fullName}
        })}
      />
      {fromShow &&
        <ButtonContainer>
          <ButtonGroup>
            <Button label="Update Asset" onPress={() => onSubmit()} />
          </ButtonGroup>
        </ButtonContainer>
      }
    </View>
  )
}

export default AssignToUsers;
